export default function PhoneMockup() {
  return (
    <div className="flex justify-center animate-float">
      {/* Phone shell */}
      <div
        className="relative w-64 rounded-[2.5rem] overflow-hidden"
        style={{
          background: '#0e0e18',
          border: '2px solid rgba(0,229,160,0.2)',
          boxShadow: '0 0 60px rgba(0,229,160,0.15), 0 24px 48px rgba(0,0,0,0.6)',
          padding: '0.75rem',
        }}
      >
        {/* Notch */}
        <div className="flex justify-center mb-3">
          <div className="w-16 h-1.5 bg-surface2 rounded-full" />
        </div>

        {/* Screen content */}
        <div className="space-y-3">
          {/* App header */}
          <div className="flex items-center justify-between px-1">
            <span className="font-syne font-bold text-sm text-accent">ParkPing</span>
            <span className="text-xs text-brand-muted">🔒 Private</span>
          </div>

          {/* Vehicle tag card 1 */}
          <div
            className="rounded-2xl p-3 space-y-2"
            style={{ background: '#1c1c26', border: '1px solid rgba(0,229,160,0.15)' }}
          >
            <div className="flex items-center gap-2">
              <span className="text-lg">🚗</span>
              <div>
                <p className="text-xs font-bold text-brand-text tracking-widest">MH 02 AB 1234</p>
                <p className="text-[10px] text-brand-muted">Car · Active</p>
              </div>
              <div
                className="ml-auto px-1.5 py-0.5 rounded-full text-[9px] font-semibold"
                style={{ background: 'rgba(0,229,160,0.15)', color: '#00e5a0' }}
              >
                LIVE
              </div>
            </div>

            {/* Action buttons row */}
            <div className="flex gap-1.5">
              <button
                className="flex-1 py-1.5 rounded-xl text-[9px] font-semibold text-bg"
                style={{ background: '#00e5a0' }}
              >
                📞 Call
              </button>
              <button
                className="flex-1 py-1.5 rounded-xl text-[9px] font-semibold"
                style={{ background: '#1a2e27', color: '#00e5a0', border: '1px solid rgba(0,229,160,0.3)' }}
              >
                💬 WhatsApp
              </button>
              <button
                className="flex-1 py-1.5 rounded-xl text-[9px] font-semibold"
                style={{ background: '#1a2e27', color: '#00e5a0', border: '1px solid rgba(0,229,160,0.3)' }}
              >
                ✉️ SMS
              </button>
            </div>
          </div>

          {/* Child tag card */}
          <div
            className="rounded-2xl p-3 space-y-2"
            style={{ background: '#1c1c26', border: '1px solid rgba(99,179,237,0.2)' }}
          >
            <div className="flex items-center gap-2">
              <span className="text-lg">👶</span>
              <div className="flex-1">
                <p className="text-xs font-bold text-brand-text">Arjun</p>
                <p className="text-[10px] text-brand-muted">Child · 5 yrs · Active</p>
              </div>
              <div
                className="px-1.5 py-0.5 rounded-full text-[9px] font-semibold"
                style={{ background: 'rgba(99,179,237,0.15)', color: '#63b3ed' }}
              >
                SAFE
              </div>
            </div>
            <div className="flex gap-1.5">
              <button
                className="flex-1 py-1.5 rounded-xl text-[9px] font-semibold"
                style={{ background: '#63b3ed', color: '#0a0a0f' }}
              >
                📞 Call
              </button>
              <button
                className="flex-1 py-1.5 rounded-xl text-[9px] font-semibold"
                style={{ background: 'rgba(99,179,237,0.12)', color: '#63b3ed', border: '1px solid rgba(99,179,237,0.3)' }}
              >
                💬 WhatsApp
              </button>
              <button
                className="flex-1 py-1.5 rounded-xl text-[9px] font-semibold"
                style={{ background: 'rgba(99,179,237,0.12)', color: '#63b3ed', border: '1px solid rgba(99,179,237,0.3)' }}
              >
                ✉️ SMS
              </button>
            </div>
          </div>

          {/* Pet tag card */}
          <div
            className="rounded-2xl p-3 space-y-2"
            style={{ background: '#1c1c26', border: '1px solid rgba(251,191,36,0.2)' }}
          >
            <div className="flex items-center gap-2">
              <span className="text-lg">🐕</span>
              <div className="flex-1">
                <p className="text-xs font-bold text-brand-text">Bruno</p>
                <p className="text-[10px] text-brand-muted">Dog · Labrador · Active</p>
              </div>
              <div
                className="px-1.5 py-0.5 rounded-full text-[9px] font-semibold"
                style={{ background: 'rgba(251,191,36,0.15)', color: '#fbbf24' }}
              >
                LIVE
              </div>
            </div>
            <div className="flex gap-1.5">
              <button
                className="flex-1 py-1.5 rounded-xl text-[9px] font-semibold"
                style={{ background: '#fbbf24', color: '#0a0a0f' }}
              >
                📞 Call
              </button>
              <button
                className="flex-1 py-1.5 rounded-xl text-[9px] font-semibold"
                style={{ background: 'rgba(251,191,36,0.12)', color: '#fbbf24', border: '1px solid rgba(251,191,36,0.3)' }}
              >
                💬 WhatsApp
              </button>
            </div>
          </div>

          {/* Privacy badge */}
          <div
            className="flex items-center justify-center gap-1.5 py-2 rounded-2xl"
            style={{ background: 'rgba(0,229,160,0.08)', border: '1px solid rgba(0,229,160,0.2)' }}
          >
            <span className="text-xs">🛡️</span>
            <span className="text-[10px] font-semibold text-accent">Your number stays hidden</span>
          </div>
        </div>
      </div>
    </div>
  )
}
